var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduateAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68857 9.05869C1.77048 8.64797 1.77047 7.35203 2.68857 6.94131L11.0416 3.20451C11.6511 2.93183 12.3489 2.93183 12.9584 3.20451L21.3114 6.94131C22.2295 7.35203 22.2295 8.64797 21.3114 9.05869L12.9584 12.7955C12.3489 13.0682 11.6511 13.0682 11.0416 12.7955L2.68857 9.05869Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.736V18C5 19.6569 6.34315 21 8 21H16C17.6569 21 19 19.6569 19 18V11.736L13.571 14.1647C12.5717 14.6118 11.4283 14.6118 10.429 14.1647L5 11.736Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduateAlt);
export default __webpack_public_path__ + "static/media/graduate-alt.fb4bd5e4cd3dffe637ed136c9712fb5a.svg";
export { ForwardRef as ReactComponent };